import { Link, Outlet } from 'react-router-dom';
import { Box, HStack, Image, Text } from '@chakra-ui/react';

import layoutImg from '../../assets/auth/layout.webp';

export const AuthLayout = () => {
  return (
    <HStack
      h="100vh"
      overflowY="scroll"
      align="start"
      px={{ base: '4', '2xl': '6' }}
    >
      <Box
        flexBasis="58%"
        h="full"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Link to="/">
          <Text
            fontSize={{ base: '3xl', '2xl': '5xl' }}
            fontWeight="bold"
            position="absolute"
            left="4"
            top="4"
          >
            <Text as="span" color="custom_blue.1">
              Brick
            </Text>
            <Text as="span" color="custom_orange.2">
              Lynk
            </Text>
          </Text>
        </Link>

        <Outlet />
      </Box>

      <Box flexBasis="42%" h="full">
        <Image src={layoutImg} alt="Engineers" maxH="full" />
      </Box>
    </HStack>
  );
};
